import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-details',
  templateUrl: './master-details.component.html',
  styleUrls: ['./master-details.component.css']
})
export class MasterDetailsComponent implements OnInit {
  menuList:any;
  pageList:any;
  
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Master')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/master/master-details/master-details.component.ts